import ApiService from '../service/ApiServiceFetch';
import MethodeService from '../service/MethodService';

let moduleApi = {};
let moduleName = "";

moduleApi.getPrefillId = (data) => {
    let objData = {
        method: "POST",
        url: "https://survey-api.siten.vn/api/survey/v1/prefills/",
        params: {},
        data: data,
        type: "",
        message: {
            success: "",
            error: "",
        },
    };
    return ApiService(objData);
}

moduleApi.getFile = (id) => {
    let objData = {
        method: "GET",
        url: "http://survey-api.siten.vn/api/survey/v1/mushroom_files/" + id,
        params: {},
        type: "",
        message: {
            success: "",
            error: ""
        }
    };
    return ApiService(objData);
}
export default moduleApi;